import { SELECT_MENU_CLASS_NAME } from '../../constants/select';
import FingoMuiPaper, { selectMenuStyles } from '../../fingo/components/MuiPaper';

const MuiPaper = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiPaper.styleOverrides.root({ theme }),
      [`&.${SELECT_MENU_CLASS_NAME}`]: selectMenuStyles({
        theme,
        mainSelectColor: theme.palette.secondary.A400,
      }),
    }),
  },
};

export default MuiPaper;
